import { createContext, useContext } from "react";

import type { OrganizationAssistantCampaignType } from "@simplyk/common";

export interface ServiceEntryPanel {
  onRecommend: (campaignType: OrganizationAssistantCampaignType) => void;
}

const ServiceEntryPanelContext = createContext<ServiceEntryPanel | null>(null);

export const ServiceEntryPanelProvider = ServiceEntryPanelContext.Provider;

export const useServiceEntryPanel = () => useContext(ServiceEntryPanelContext);
